type OptionArg = {
  label: string;
  val: any;
}[];
export const getFilterOption = (
  postUser: string,
  questionOptions: OptionArg = []
) => {
  const filterOption = [{ label: '全てのチャットを表示', val: 'all' }];
  if (postUser === 'student') {
    filterOption.push({
      label: '回答中の問題に対するチャットを表示',
      val: 'current'
    });
  }

  if (postUser === 'admin') {
    if (questionOptions.length > 0) {
      filterOption.push(...questionOptions);
    }
  }
  return filterOption;
};

export const getChatPlaceholder = (postUser: string) => {
  switch (postUser) {
    case 'admin':
      return '講師のコメントを入力';
    case 'student':
      return '質問を入力';
    default:
      // 例外時は当たり障りのないplaceholderにする
      return 'コメントを入力';
  }
};
